module.exports = ".form-inline .form-control {\n  width: auto;\n  display: inline-block;\n}\n"